import firebaseUtil from "firebaseUtil";


export function salvarPerfilLogin(UserFirebase) {
    let obj = { uid: UserFirebase.uid, name: UserFirebase.displayName, email: UserFirebase.email, emailVerified: UserFirebase.emailVerified };
    obj.firstLogin = firebaseUtil.firestore().FieldValue.serverTimestamp()
    let updateForce = { lastLogin: firebaseUtil.firestore().FieldValue.serverTimestamp()}
    updateForce.login_version = process.env.REACT_APP_VERSION
    saveOnlyNew(obj, "PerfilUser", updateForce)

}
export function salvarPerfilRegistro(UserFirebase, add) {
    let obj = { uid: UserFirebase.uid, name: UserFirebase.displayName, email: UserFirebase.email, emailVerified: UserFirebase.emailVerified };
    obj.firstLogin = firebaseUtil.firestore().FieldValue.serverTimestamp()
    if (add) {
        obj = { ...obj, ...add }
    }

    saveOnlyNew(obj, "PerfilUser")
}

export function saveOnlyNew(obj, colectionStr, ifExistOnlyUpdateData) {
    let colection = firebaseUtil.db.collection(colectionStr);
    const { uid } = obj;
    let docSalvar = null;
    if (uid) {
        docSalvar = colection.doc(uid);
    } else {
        docSalvar = colection.doc();
        obj.uid = docSalvar.id;
    }

    obj.lastChange = firebaseUtil.firestore().FieldValue.serverTimestamp()
    if (ifExistOnlyUpdateData) {
        docSalvar.get()
            .then((docSnapshot) => {
                if (docSnapshot.exists) {
                    let dataUpdate = { uid, lastChange: firebaseUtil.firestore().FieldValue.serverTimestamp(), ...ifExistOnlyUpdateData }

                    docSalvar.set(dataUpdate, { merge: true })
                } else {
                    docSalvar.set(obj, { merge: true })
                }
            })
            .catch(err => {
                console.log('err', err)
                console.log('obj', obj)
            })
    } else {
        docSalvar.set(obj, { merge: true })
    }

}
//#region - crateSnapDocument (nao consideraPermissao)
export function crateSnapDocument(uid, strCollection, resolve, reject, uidUser) {
    return crateSnapDocumentDatabase(firebaseUtil.db, uid, strCollection, resolve, reject, uidUser)
}
export function crateSnapDocumentDatabase(database, uid, strCollection, resolve, reject, uidUser) {
    if (!database) database = firebaseUtil.db;
    // console.log("buscaSyncCollection", strCollection);
    let docSalvar = database.collection(strCollection).doc(uid);
    let observer = docSalvar.onSnapshot(docSnapshot => {
        if (docSnapshot.exists) {
            resolve(docSnapshot.data())
        } else {
            reject({ message: "not fond", code: 404 })
        }
    }, err => {
        console.log("buscaSyncObj error:", err);
        reject(err)
    });
    return observer;
}

//#endregion
//#region - crateSnapColectins (nao consideraPermissao)
export function getCollectionApi(strCollection) {
    return firebaseUtil.db.collection(strCollection);
}
//#endregion

